/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/

// @mui material components
import { Card } from '@mui/material'
import Grid from '@mui/material/Grid'
import Icon from '@mui/material/Icon'
import Divider from '@mui/material/Divider'
import Avatar from '@mui/material/Avatar'

// MD UI Dashboard PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

// MD UI Dashboard PRO React example components
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import DataTable from 'examples/Tables/DataTable'
import AppData from './components/data-tables/data/dataTableData'
import MDButton from 'components/MDButton'
import CreateModal from './components/CreateModal'
import { useEffect, useState } from 'react'
import { useAppServices } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import Loader from 'examples/Loader'

function Default() {
  const AppService = useAppServices()
  const [agency] = useAgencyInfo()
  const { dataTableData, handleRefresh, products, apps, loader, category } = AppData()
  const [users, setUsers] = useState([])
  
  const GetUsers = async () => {
    const { response } = await AppService.AppInstallUser.get({
      toaster: false,
    })
    if (response) {
      console.log(response.data, "ressss")
      setUsers(response.data)
    }
  }
  
  useEffect(() => {
    GetUsers()
  }, [])

  // Function to format date
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' }
    return new Date(dateString).toLocaleDateString(undefined, options)
  }

  return (
    <DashboardLayout>
      {loader ? (
        <Loader />
      ) : (
        <>
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                {/* <Card> */}
                  <MDBox p={3}>
                    <MDTypography variant="h5" fontWeight="medium">
                      Connected Locations
                    </MDTypography>
                    <MDBox mt={3}>
                      {users && users.length > 0 ? (
                        users.map((user, index) => (
                          <MDBox 
                            key={user._id} 
                            mb={index !== users.length - 1 ? 3 : 0}
                            p={2.5}
                            sx={{ 
                              border: '1px solid #eee', 
                              borderRadius: '10px',
                              boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
                              transition: 'transform 0.3s',
                              '&:hover': { transform: 'translateY(-5px)', boxShadow: '0 5px 15px 0 rgba(0, 0, 0, 0.15)' }
                            }}
                          >
                            <Grid container spacing={2} alignItems="center">
                              <Grid item xs={12} md={1}>
                                <Avatar sx={{ bgcolor: '#1A73E8', width: 56, height: 56 }}>
                                  {user.name.charAt(0)}
                                </Avatar>
                              </Grid>
                              <Grid item xs={12} md={11}>
                                <Grid container spacing={2}>
                                  <Grid item xs={12} md={6}>
                                    <MDTypography variant="h6" fontWeight="medium">
                                      {user.name}
                                    </MDTypography>
                                    <MDTypography variant="body2" color="text">
                                      Email: {user.email}
                                    </MDTypography>
                                    <MDTypography variant="body2" color="text">
                                      Phone: {user.phone}
                                    </MDTypography>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <MDTypography variant="body2" color="text">
                                      <strong>Location ID:</strong> {user.location_id}
                                    </MDTypography>
                                    <MDTypography variant="body2" color="text">
                                      <strong>App ID:</strong> {user.app_id}
                                    </MDTypography>
                                    <MDTypography variant="body2" color="text">
                                      <strong>Company ID:</strong> {user.company_id}
                                    </MDTypography>
                                    <MDTypography variant="body2" color="text">
                                      <strong>Type:</strong> {user.type}
                                    </MDTypography>
                                    <MDTypography variant="body2" color="text">
                                      <strong>Created:</strong> {formatDate(user.createdAt)}
                                    </MDTypography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </MDBox>
                        ))
                      ) : (
                        <MDBox textAlign="center" p={3}>
                          <MDTypography variant="body1" color="text">
                            No connected locations found.
                          </MDTypography>
                        </MDBox>
                      )}
                    </MDBox>
                  </MDBox>
                {/* </Card> */}
              </Grid>
            </Grid>
          </MDBox>
        </>
      )}
    </DashboardLayout>
  )
}

export default Default
